/**
 * 문자열에서 숫자만 추출한다.
 *
 * @param val - 숫자를 추출할 대상 문자열.
 * @returns 숫자만 포함된 문자열. 입력에 숫자가 없는 경우 빈 문자열을 반환.
 *
 * @example
 * getOnlyNumbers('abc123'); // '123'
 * getOnlyNumbers('12,345.67'); // '1234567'
 * getOnlyNumbers('abcd'); // '' (숫자가 없는 경우)
 */
export const getOnlyNumbers = (val: string): string => {
  return val.replace(/[^0-9]/g, '');
};

/**
 * 주어진 수에 천단위 쉼표를 추가하고, 소수점이 있는 경우 소수점을 유지한다.
 *
 * @param num - 쉼표를 추가할 숫자 또는 숫자 문자열. 기본값은 0.
 * @returns 쉼표가 추가된 문자열.
 *
 * @example
 * numberFormat(12000); // '12,000'
 * numberFormat(1050.3644); // '1,050.3644'
 * numberFormat('56789.01'); // '56,789.01'
 * numberFormat(0.1234); // '0.1234'
 * numberFormat('abcd'); // '0' (잘못된 입력 처리)
 */
export function numberFormat(num: string | number = 0): string {
  if (Number.isNaN(Number(num))) {
    return '0';
  }

  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}
